// extracted by mini-css-extract-plugin
module.exports = {"header":"HDFFiY","accordionData":"hjtNzj","accordionOpen":"SZRjbz"};